export default "__VITE_ASSET__D82tcJeA__"